import React, { useEffect } from 'react';
import PageMeta from '../components/PageMeta';
import { mockData } from '../mock';

const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <PageMeta
        title="Terms of Service"
        description="Review the terms of service for Global Trademark Federation. Understand the conditions and agreements for using our trademark registration and intellectual property services."
      />
      <div className="container mx-auto px-4 pt-28 pb-20 max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-12">Terms of Service</h1>

        <div className="prose prose-lg max-w-none space-y-8">
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-700 leading-relaxed">
              By accessing and using the services provided by Global Trademark Federation ("Company," "we," "our," or "us"), you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Services Description</h2>
            <p className="text-gray-700 leading-relaxed">
              Global Trademark Federation provides trademark registration, copyright registration, company formation, trademark search, and related intellectual property services. Our services are designed to assist clients in protecting their brands and intellectual property in the United States.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Professional Services</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              While we provide professional trademark services, we make no guarantees regarding:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Approval of trademark applications by the USPTO</li>
              <li>Success in defending against office actions or oppositions</li>
              <li>Prevention of third-party infringement</li>
              <li>Specific timelines for government processing</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4">
              Our role is to provide expert guidance and file applications properly, but final decisions rest with government authorities.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Client Responsibilities</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              As a client, you agree to:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Provide accurate and complete information</li>
              <li>Respond to our requests for information in a timely manner</li>
              <li>Review all documents before submission</li>
              <li>Pay all fees in accordance with our pricing structure</li>
              <li>Comply with all applicable laws and regulations</li>
              <li>Use your trademark in commerce as required by law</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Fees and Payment</h2>
            <p className="text-gray-700 leading-relaxed">
              All service fees are clearly stated on our website and must be paid in advance. Government filing fees are separate and must be paid in addition to our service fees. All fees are non-refundable once work has commenced, except as otherwise specified in writing.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Intellectual Property Rights</h2>
            <p className="text-gray-700 leading-relaxed">
              You retain all rights to your trademarks and intellectual property. All materials we create for your application become your property upon full payment. The Global Trademark Federation name, logo, and website content are our intellectual property.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Confidentiality</h2>
            <p className="text-gray-700 leading-relaxed">
              We maintain strict confidentiality regarding all client information, except as required by law or necessary to provide our services (such as filing with the USPTO).
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Limitation of Liability</h2>
            <p className="text-gray-700 leading-relaxed">
              To the maximum extent permitted by law, Global Trademark Federation shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues. Our total liability shall not exceed the fees paid by you for the specific service in question.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Disclaimer of Warranties</h2>
            <p className="text-gray-700 leading-relaxed">
              Our services are provided "as is" without warranties of any kind, either express or implied. We do not warrant that our services will be uninterrupted, error-free, or that results will meet your expectations.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Termination</h2>
            <p className="text-gray-700 leading-relaxed">
              Either party may terminate the service agreement with written notice. Upon termination, you remain responsible for all fees incurred up to the termination date.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Governing Law</h2>
            <p className="text-gray-700 leading-relaxed">
              These Terms of Service shall be governed by and construed in accordance with the laws of the State of New York, without regard to its conflict of law provisions.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Dispute Resolution</h2>
            <p className="text-gray-700 leading-relaxed">
              Any disputes arising from these terms or our services shall first be attempted to be resolved through good faith negotiation. If negotiation fails, disputes shall be resolved through binding arbitration in New York, NY.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">13. Changes to Terms</h2>
            <p className="text-gray-700 leading-relaxed">
              We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting to our website. Your continued use of our services constitutes acceptance of the modified terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">14. Contact Information</h2>
            <p className="text-gray-700 leading-relaxed">
              For questions about these Terms of Service, please contact us at:
            </p>
            <div className="bg-gray-50 p-6 rounded-lg mt-4">
              <p className="text-gray-700"><strong>Global Trademark Federation</strong></p>
              <p className="text-gray-700">Email: {mockData.contact.email}</p>
              <p className="text-gray-700">Phone: {mockData.contact.phone}</p>
              <p className="text-gray-700"><strong>Head Office:</strong> {mockData.contact.headOffice}</p>
              <p className="text-gray-700"><strong>Corporate Building:</strong> {mockData.contact.corporateBuilding}</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
